/**
 * Created by andrey on 28.03.2024.
 */

const AdjustLogger = function () {
    this.config = {
        lifetime: "180 days"
    };
};

AdjustLogger.prototype.getConfig = function () {
    const json = connector.config.adjust;
    return json[connector.info.source] || json;
};

AdjustLogger.prototype.trackEvent = function (name) {
    const config = this.getConfig();

    const eventToken = config.events && config.events[name];
    if (!eventToken) {
        return;
    }

    connector.platform.callNative("AdjustPlugin.logEvent", { eventToken });
};

AdjustLogger.prototype.trackPurchase = function (product, purchase, params) {
    const config = this.getConfig();

    connector.platform.callNative("AdjustPlugin.logPurchase", {
        eventToken: config.purchaseToken,
        transactionID: params.transactionId,
        amount: params.price,
        currency: params.currency
    });
};

AdjustLogger.prototype.trackAdRevenue = function (name, impressionCost, params) {
    connector.platform.callNative("AdjustPlugin.logAdRevenue", {
        revenue: impressionCost,
        source: params.source
    });
};

AdjustLogger.isApplicable = function () {
    const result = connector.platform.oneOf(connector.ANDROID, connector.AMAZON, connector.IOS, connector.MICROSOFT);

    let json = connector.config.adjust;
    json = json && json[connector.info.source] || json;

    if (result && (!json || !json.purchaseToken)) {
        console.error("empty adjust config");
        return false;
    }

    return result;
};

AdjustLogger.loadConfig = function (callback) {
    if (!connector.platform.oneOf(connector.ANDROID, connector.AMAZON, connector.IOS, connector.MICROSOFT)) {
        callback();
        return;
    }

    const onAdjustLoaded = (adjust) => {
        console.log(`loaded adjust config - ${JSON.stringify(adjust)}`);
        if (!adjust && window.CONNECTOR_ADJUST) {
            console.log("[connector] Failed to load adjust config, falling back to local config");
            adjust = window.CONNECTOR_ADJUST;
        }

        connector.config.adjust = adjust;

        callback();
    };

    const adjust = window.CONNECTOR_ADJUST;

    let url;

    if (adjust && adjust.remote && adjust.remote.startsWith("remoteconfig://") && connector.config.remoteConfigURL) {
        url = adjust.remote;
    } else if (connector.config.payApiURL) {
        url = `${connector.config.payApiURL}/adjust.json`;
    }

    if (url) {
        connector._loadConfig(
            url,
            connector.utils.waitNoMore(10000, onAdjustLoaded)
        );
    } else {
        onAdjustLoaded(undefined);
    }
};
